import React from 'react';
import { useParams } from 'react-router-dom';

import PortfolioContainer from '@totem/components/services/optimize/v2/dashboard/PortfolioContainer';
import PortfolioPanel from '@totem/components/services/optimize/v2/dashboard/PortfolioPanel';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const BuildingDashboardPage = () => {
  const { buildingId } = useParams<{ buildingId: string }>();

  return (
    <ContentLayout>
      <PortfolioContainer buildingId={buildingId}>
        <IBCard isCovered title="Optimize — Building Dashboard">
          <PortfolioPanel />
        </IBCard>
      </PortfolioContainer>
    </ContentLayout>
  );
};

export default BuildingDashboardPage;
